import { gql } from '@apollo/client';

export const CREATE_SCREENER_SESSION = gql`
  mutation CreateScreenerSession($testerId: ID!) {
    createScreenerSession(testerId: $testerId) {
      screenerSession {
        id
        authenticationToken
      }
    }
  }
`;

export const GET_PROJECT_BY_ID = gql`
  query Project($projectId: ID!) {
    project(id: $projectId) {
      id
      status
      segments {
        id
        surveys {
          id
          surveyType
        }
      }
    }
  }
`;
